import { BasketballGame } from '@hefe/models';
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import API from '../../../api/api';
import { BasketballEventTaskAssignPlayersRequest } from '../../../models/requests/basketball-event-tasks';

const FEATURE_KEY = 'basketballEventTasks';

/************************************************************************************
 *
 *                                  ACTIONS
 *
 ************************************************************************************
 */

const assignUsersToBasketballEventTask = createAsyncThunk(
  'basketballEventTasks/assignUsersToBasketballEventTask',
  async (
    {
      taskId,
      requestData,
    }: { taskId: number; requestData: BasketballEventTaskAssignPlayersRequest },
    thunkAPI
  ) => {
    const response = await API.basketballMyTeamTasks().assign(
      taskId,
      requestData
    );
    return response?.data;
  }
);

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface BasketballEventTasksState {
  clubGames: BasketballGame[];
  gameDetails: {
    loading: boolean;
    game: BasketballGame | null;
  };
}

const initialState: BasketballEventTasksState = {
  clubGames: [],
  gameDetails: {
    loading: false,
    game: null,
  },
};

const basketballEventTasksSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {},
});

/*
 * Export reducer for store configuration.
 */
const reducer = basketballEventTasksSlice.reducer;
const actions = basketballEventTasksSlice.actions;

const getBasketballGamesState = (rootState: any): BasketballEventTasksState =>
  rootState[FEATURE_KEY];

const basketballGamesState = createSelector(
  getBasketballGamesState,
  (state) => state
);

export {
  actions,
  assignUsersToBasketballEventTask,
  basketballEventTasksSlice,
  basketballGamesState,
  reducer,
};
